const deprecatedIllustrations = [
  "https:/*                                  */
  "https:/*                           */
  "https:/*                             */
  "https:/*                       */
  "https:/*                             */
  "https:/*                           */
  "https:/*                          */
  "https:/*                           */
  "https:/*                                  */
  "https:/*                               */
  "https:/*                               */
  "https:/*                               */
  "https:/*                            */
  "https:/*                                   */
  "https:/*                                  */
  "https:/*                                                */
];

function checkLegacyPattern(
  name: string,
  selector: string,
  dataGetter?: (elem: Element) => unknown
): void {
  const elements = document.querySelectorAll(selector);
  const { stack } = Error("");
  const pagecluster = window.o_util.misc.getPagecluster();

  const data = dataGetter ? Array.from(elements).map(dataGetter) : undefined;

  if (elements.length > 0) {
    window.AS.RUM.sendCustomRequest("assets-legacy-pattern", {
      name,
      pagecluster,
      count: elements.length,
      stack,
      data,
    });
  }
}

function checkLegacyIllustrations(): void {
  const selector = deprecatedIllustrations.map((url) => `[src^='${url}']`).join(",");

  checkLegacyPattern("illustrations", selector, (el) => el.getAttribute("src"));
}

function logLegacyWarnings(): void {
  if (window.o_util.toggle.get("ASSETS_LEGACY_Illustrations", false)) {
    checkLegacyIllustrations();
  }

  if (window.o_util.toggle.get("ASSETS_LEGACY_chip", false)) {
    checkLegacyPattern("chip", ".pl_chip");
  }

  if (window.o_util.toggle.get("ASSETS_LEGACY_expander", false)) {
    checkLegacyPattern("expander", ".p_expander");
  }
}

export { logLegacyWarnings };
